import { render, staticRenderFns } from "./UploadTrainingVideoModal.vue?vue&type=template&id=b48572a8&scoped=true&"
import script from "./UploadTrainingVideoModal.vue?vue&type=script&lang=js&"
export * from "./UploadTrainingVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./UploadTrainingVideoModal.vue?vue&type=style&index=0&id=b48572a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48572a8",
  null
  
)

export default component.exports